<template>
	<div>
		<PageWatcher @updateActiveTocId="updateActiveTocId" />
		<div v-if="page">
			<ContentRenderer :value="page" />
		</div>
		<DocumentDrivenNotFound v-else />
		<DialogProfile :openDialog="userStore.openProfileDialog" />
	</div>
</template>

<script setup lang="ts">
import { useUserStore } from '../stores/user';
const userStore = useUserStore();
const route = useRoute();

// @nuxt/content v3: documentDriven is gone, so the catch-all fetches the doc
// for the current route explicitly.
const { data: page } = await useAsyncData(`content:${route.path}`, () =>
	queryCollection('content').path(route.path).first()
);

// Honour `redirect:` frontmatter (nucleus editor stubs, gmg/design/*).
// documentDriven used to do this automatically.
if (page.value?.redirect) {
	await navigateTo(page.value.redirect);
}

// Dynamic layout from frontmatter (almost everything uses default).
if (page.value?.layout) {
	setPageLayout(page.value.layout as any);
}

// Surround (prev/next) for the right sidebar.
const { data: surround } = await useAsyncData(`surround:${route.path}`, () =>
	queryCollectionItemSurroundings('content', route.path)
);

// Publish to the layout/TOC/heading-observer (replaces useContent()).
const currentDoc = useCurrentDoc();
const currentSurround = useCurrentSurround();
currentDoc.value = page.value ?? null;
currentSurround.value = (surround.value as any[]) ?? [];

// Per-path key so the component remounts on each content navigation and this
// setup re-runs (re-fetch + re-publish currentDoc).
definePageMeta({
	layout: 'default',
	key: (route) => route.path,
});

const updateActiveTocId = (_id: string) => {
	// Active heading is tracked by PageWatcher and surfaced in the right sidebar.
};
</script>

<style scoped></style>
